// extracted by mini-css-extract-plugin
export const slideMenu = "bm_cJ";
export const menuItem = "bm_cK";
export const appIcon = "bm_bY";